<div
  class="record-card mb-5"
  [class.backgroundGrey]="rowIndex % 2 === 0"
  [class.backgroundWhite]="rowIndex % 2 !== 0"
  [ngClass]="editMode === true ? 'backgroundGrey' : ''"
>
  <div class="record-layout">
    <!-- LEFT PANEL -->
    <div class="info-panel">
      <p [appCancelColor]="isCancelIssue">{{ issue.issueNo }}</p>

      <p [appCancelColor]="isCancelIssue">{{ issue.entityCode }}</p>

      <div class="d-Flex">
        <h2>Contact:</h2>
        <p class="ml-5" [appCancelColor]="isCancelIssue">{{ issue.contact }}</p>
      </div>

      <div class="d-Flex">
        <h2>Approver:</h2>
        <p class="ml-5" [appCancelColor]="isCancelIssue">{{ issue.approver }}</p>
      </div>

      <div class="d-Flex">
        <h2>Created On:</h2>
        <p class="ml-5" [appCancelColor]="isCancelIssue">{{ issue.createdOn }}</p>
      </div>

      <div class="d-Flex">
        <h2>Modified On:</h2>
        <p class="ml-5" [appCancelColor]="isCancelIssue">{{ issue.modifiedOn }}</p>
      </div>
    </div>

    <!-- YEAR -->
    <div>
      <h2 class="text-center pr-5" [appCancelColor]="isCancelIssue">
        {{ yearRow?.year }}
      </h2>
    </div>

    <!-- MATRIX -->
    <div class="matrix-panel">
      @for (row of issue.details; track row.label) {
        @if (row.label === 'FTC' || row.label === 'Issue') {
          <div class="section-divider"></div>
        }
        @if (row.label !== 'Issue') {
          <div
            class="matrix-row"
            [class.no-bottom-border]="row.label.endsWith('net TI') || row.label === 'GBC'"
          >
            <div class="row-label">
              <h2 class="pr-10">
                {{ row.label }}
              </h2>
            </div>

            <div>
              <p [appCancelColor]="isCancelIssue">{{ row.us | number }}</p>
            </div>

            <div>
              <p [appCancelColor]="isCancelIssue">{{ row.passive | number }}</p>
            </div>

            <div class="customRightBorder">
              <p [appCancelColor]="isCancelIssue">{{ row.capitalGain | number }}</p>
            </div>

            <div>
              <p [appCancelColor]="isCancelIssue">{{ row.general | number }}</p>
            </div>

            <div>
              <p [appCancelColor]="isCancelIssue">{{ row.fogei | number }}</p>
            </div>

            <div class="customRightBorder">
              <p [appCancelColor]="isCancelIssue">{{ row.fori | number }}</p>
            </div>

            <div>
              <p [appCancelColor]="isCancelIssue">{{ row.brNogi | number }}</p>
            </div>

            <div>
              <p [appCancelColor]="isCancelIssue">{{ row.brCfogi | number }}</p>
            </div>

            <div>
              <p [appCancelColor]="isCancelIssue">{{ row.nbrNogi | number }}</p>
            </div>

            <div>
              <p [appCancelColor]="isCancelIssue">{{ row.nbrCfogi | number }}</p>
            </div>

            <div>
              <p [appCancelColor]="isCancelIssue">{{ row.giltiNogi | number }}</p>
            </div>

            <div>
              <p [appCancelColor]="isCancelIssue">{{ row.giltiFori | number }}</p>
            </div>
          </div>
        }
      }
    </div>
  </div>

  <!-- ISSUE ROW -->
  <div class="issue-detail-row align-items-center">
    <div class="issue-icons pl-10">
      @if (!editMode) {
        <div class="d-flex justify-content-center align-items-center gap-3 actionColumn">
          <!-- Audit Trail Records -->
          <button type="button" class="btn btn-link p-0 successIcon iconCSS" (click)="showAudit()">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              stroke-width="1.75"
            >
              <title>Audit Trail Records</title>
              <path d="M4 3h11l5 5v13H4z" fill="#f8f8f8" stroke="#0b2d71" />
              <circle cx="8" cy="10" r="1.2" fill="#0b2d71" />
              <circle cx="8" cy="14" r="1.2" fill="#0b2d71" />
              <circle cx="8" cy="18" r="1.2" fill="#0b2d71" />
              <line x1="8" y1="10" x2="8" y2="18" stroke="#0b2d71" />
              <line x1="11" y1="10" x2="17" y2="10" stroke="#0b2d71" />
              <line x1="11" y1="14" x2="17" y2="14" stroke="#0b2d71" />
              <line x1="11" y1="18" x2="15" y2="18" stroke="#0b2d71" />
            </svg>
          </button>

          <!-- Edit Issue -->
          @if (isAdminUser) {
            <button
              type="button"
              class="btn btn-link p-0 successIcon iconCSS"
              (click)="editRecord()"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="#0b2d71"
                stroke-width="2.2"
              >
                <title>Edit Issue</title>
                <path d="M12 20h9"></path>
                <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4 12.5-12.5z"></path>
              </svg>
            </button>
          }
        </div>
      }
    </div>

    <div class="issue-content align-items-center">
      <h2>Issue</h2>
      <p class="customPara customParaHeight" [appCancelColor]="issue.irsIssueId === 'Cancel'">
        {{ issueRow?.issueText }}
      </p>
    </div>
  </div>

  <!-- ASC ROW -->
  <div class="asc-row">
    <h2>ASC 740-10</h2>
    @if (!editMode) {
      @if (issue.asC_740Flag) {
        <div class="image-checkbox-checked" [class.checked]="true">✓</div>
      } @else {
        <div class="image-checkbox-unchecked" [class.checked]="false"></div>
      }
    } @else {
      <input
        type="checkbox"
        [checked]="issueEditData.ascFlag"
        [(ngModel)]="issueEditData.ascFlag"
      />
    }

    @if (!editMode) {
      <p class="pl-5">{{ issueEditData.ascIssueId }}</p>
    } @else {
      <div class="asc-no-cell">
        @if (issueEditData.ascFlag) {
          <h2>No.</h2>
          <input
            type="text"
            class="form-control pl-5"
            placeholder="Enter ASC 740-10 No."
            aria-label="ASC 740-10 No."
            [(ngModel)]="issueEditData.ascIssueId"
          />
        }
      </div>
    }

    @if (!editMode) {
      <p class="customPara customParaHeight">
        {{ issueEditData.ascComment }}
      </p>
    } @else {
      <textarea
        class="asc-textarea"
        [(ngModel)]="issueEditData.ascComment"
        style="min-height: 1.85rem !important; height: 1.85rem !important"
      >
      </textarea>
    }
  </div>

  <!-- TBBS -->
  <div class="tbbs-row">
    @if (!editMode) {
      @if (issue.tbbsFlag) {
        <div class="image-checkbox-checked" [class.checked]="true">✓</div>
      } @else {
        <div class="image-checkbox-unchecked" [class.checked]="false"></div>
      }
    } @else {
      <input
        type="checkbox"
        [checked]="issueEditData.tbbsFlag"
        [(ngModel)]="issueEditData.tbbsFlag"
      />
    }
    <h2 class="heading">TBBS Status</h2>
    @if (!editMode) {
      <p class="tbbsStatus">
        {{ issueEditData.tbbsStatus }}
      </p>
    } @else {
      <select class="form-select" [(ngModel)]="issueEditData.tbbsStatus">
        @for (status of tbbsStatus; track status) {
          <option [value]="status">
            {{ status }}
          </option>
        }
      </select>
    }

    <h2>TBBS</h2>

    @if (!editMode) {
      <p class="customPara customParaHeight" style="margin: 0 !important">
        {{ issueEditData.tbbsDescription }}
      </p>
    } @else {
      <textarea
        class="tbbs-textarea"
        [(ngModel)]="issueEditData.tbbsDescription"
        style="min-height: 2rem !important; height: 2rem !important"
      ></textarea>
    }
  </div>

  <!-- PURPLE FOOTER -->
  <div class="ar-row tableHeaderSurface">
    <div class="ar-item">
      <h2>AR Filing ID</h2>
      <p [appCancelColor]="isCancelIssue">{{ issue.arFilingId }}</p>
    </div>

    <div class="d-Flex linkBTN" id="NPARow">
      <h2 id="npaHeading">AR Issue ID</h2>
      <p class="pl-5 linkBTN" [appCancelColor]="isCancelIssue" [title]="issue.arIssueId">
        {{ issue.arIssueId }}
      </p>
    </div>

    <div class="d-Flex linkBTN" id="NPARow">
      <h2 id="npaHeading">IRS Issue ID</h2>
      <p class="pl-5 linkBTN" [appCancelColor]="isCancelIssue" [title]="issue.irsIssueId">
        {{ issue.irsIssueId }}
      </p>
    </div>

    <div class="d-Flex linkBTN" id="NPARow">
      <h2 id="npaHeading">SAA</h2>
      <p class="pl-5 linkBTN" [appCancelColor]="isCancelIssue" [title]="issue.saaNo">
        {{ issue.saaNo }}
      </p>
    </div>

    <div class="d-Flex linkBTN" id="NPARow">
      <h2 id="npaHeading">Submission</h2>
      <p class="pl-5 linkBTN" [appCancelColor]="isCancelIssue" [title]="issue.submission">
        {{ issue.submission }}
      </p>
    </div>

    <div class="ar-item sp-link-item">
      <h2>SP Link</h2>

      @if (editMode) {
        <input
          type="text"
          class="form-control sp-link-input"
          [(ngModel)]="issueEditData.spLink"
          [title]="issueEditData.spLink"
        />
      } @else {
        <a [href]="issue.spLink" target="_blank" rel="noopener noreferrer" class="sp-link-anchor">
          <input
            type="text"
            class="form-control"
            [value]="issue.spLink"
            readonly
            tabindex="0"
            style="background-color: initial !important; cursor: pointer"
          />
        </a>
      }
    </div>

    <!-- <div class="ar-item">
      <h2>NPA</h2>
      <p [appCancelColor]="isCancelIssue">{{ issue.npa }}</p>
    </div> -->

    <div class="d-Flex linkBTN" id="NPARow">
      <h2 id="npaHeading">NPA</h2>
      <p class="pl-5 linkBTN" [appCancelColor]="isCancelIssue" [title]="issue.npa">
        {{ issue.npa }}
      </p>
    </div>

    <div class="ar-item">
      <h2>Issue Status</h2>
      <p [appCancelColor]="isCancelIssue">{{ issue.issueStatus }}</p>
    </div>
  </div>
</div>
